<payee-chip-dropdown
  [displayWith]="displayWith"
  [selected]="selected"
  [placeholder]="'CASES_TABLE.FILTERS.TRANSITION_AT.LABEL' | translate"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="clearFilter()"
>
  <div class="transition-at-form">
    <payee-form-field width="short">
      <span payee-label>{{ "CASES_TABLE.FILTERS.TRANSITION_AT.MIN_LABEL" | translate }}</span>
      <payee-datepicker
        [formControl]="fromControl"
        [max]="toControl.value || max"
      ></payee-datepicker>
    </payee-form-field>
    <button
      payee-suffix
      payee-mini-icon-button
      color="white"
      class="clear-button"
      [isBorderButton]="true"
      (click)="fromControl.patchValue(null)"
    >
      <payee-icon name="cross-black"></payee-icon>
    </button>
  </div>
  <div class="transition-at-form">
    <payee-form-field width="short">
      <span payee-label>{{ "CASES_TABLE.FILTERS.TRANSITION_AT.MAX_LABEL" | translate }}</span>
      <payee-datepicker
        [formControl]="toControl"
        [min]="fromControl.value"
        [max]="max"
      ></payee-datepicker>
    </payee-form-field>
    <button
      payee-suffix
      payee-mini-icon-button
      color="white"
      class="clear-button"
      [isBorderButton]="true"
      (click)="toControl.patchValue(null)"
    >
      <payee-icon name="cross-black"></payee-icon>
    </button>
  </div>
  <button
    payee-button
    color="primary"
    class="top-margin-10"
    width="max"
    (click)="applyFilter()"
  >
    {{ "CASES_TABLE.FILTERS.APPLY" | translate }}
  </button>
</payee-chip-dropdown>
